export default __webpack_public_path__ + "45e7db2603e328ccd592704fa71d19e6.png";